// 引入
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueCookie from 'vue-cookie'
import storage from '../utils/storage'
// 注册
Vue.use(VueRouter)

// 结构
// export const routes = [
//     // 登录
//     {
//         path: '/login',
//         component: () => import('@/views/Login/Login'),
//         meta: {
//             name: '登录',
//         }
//     },
// ]
export const routes = [
    // 登录
    {
        path: '/login',
        component: () => import('@/views/Login/Login')
    },
    // 首页路由
    {
        path: '/home',
        component: () => import('@/views/Layout/Layout'),
        redirect: '/home/homepage',
        meta: {
            name: '企业中心',
            haschild: false
        },
        children: [
            {
                path: 'homepage',
                component: () => import('@/views/Home/homepage/homepage'),
                meta: {
                    // name: '企业中心',
                }
            },
            // {
            //     path: 'parkhead',
            //     component: () => import('@/views/parkhead/parkhead'),
            //     meta: {
            //         name: '园区首页',
            //     }
            // }
        ]

    },
    // 数据检索
    {
        path: '/Data-Homepage',
        component: () => import('@/views/Layout/Layout'),
        redirect: '/Data-Homepage/Patent-search',
        meta: {
            name: '数据检索',
            haschild: true
        },
        children: [
            {
                path: 'Patent-search',
                component: () => import('@/views/Data-Homepage/Patent-search/Patent-search'),
                meta: {
                    name: '专利检索'
                }
            },
            {
                path: 'Patent-details',
                component: () => import('@/views/Data-Homepage/Patent-search/Patent-details'),
                meta: {
                    name: '专利检索详情'
                }
            },
            {
                path: 'Trademark-search',
                component: () => import('@/views/Data-Homepage/Trademark-search/Trademark-search'),
                meta: {
                    name: '商标检索'
                }
            },
            {
                path: 'Trademark-details',
                component: () => import('@/views/Data-Homepage/Trademark-search/Trademark-details'),
                meta: {
                    name: '商标检索详情'
                }
            },
            {
                path: 'Enterprise-search',
                component: () => import('@/views/Data-Homepage/Enterprise-search/Enterprise-search'),
                meta: {
                    name: '企业检索'
                }
            },
            {
                path: 'Enterprise-details',
                component: () => import('@/views/Data-Homepage/Enterprise-search/Enterprise-details'),
                meta: {
                    name: '企业检索详情'
                }
            },
        ]
    },
    // 产品研发
    {
        path: '/development-Administration',
        component: () => import('@/views/Layout/Layout'),
        redirect: '/development-Administration/product-management',
        meta: {
            name: '产品研发',
            haschild: true
        },
        children: [
            {
                path: 'product-management',
                component: () => import('@/views/development-Administration/product-management/product-management'),
                meta: {
                    name: '产品管理'
                }
            },
            {
                path: 'product-addfication',
                component: () => import('@/views/development-Administration/product-management/product-addfication'),
                meta: {
                    name: '产品增加'
                }
            },
            {
                path: 'product-modification',
                component: () => import('@/views/development-Administration/product-management/product-modification'),
                meta: {
                    name: '产品修改'
                }
            },
            {
                path: 'Science-projects',
                component: () => import('@/views/development-Administration/Science-projects/Science-projects'),
                meta: {
                    name: '研发项目'
                }
            },
            // {
            //     path: 'Cost-collection',
            //     component: () => import('@/views/development-Administration/Cost-collection/Cost-collection'),
            //     meta: {
            //         name: '费用归集'
            //     }
            // },
            {
                path: 'gantt',
                component: () => import('@/views/development-Administration/gantt/gantt'),
                meta: {
                    name: '测试gantt'
                }
            },
            // {
            //     path: 'Science-addfication',
            //     component: () => import('@/views/development-Administration/Science-projects/Science-addfication'),
            //     meta: {
            //         name: '研发增加'
            //     }
            // },
            // {
            //     path: 'Science-modification',
            //     component: () => import('@/views/development-Administration/Science-projects/Science-modification'),
            //     meta: {
            //         name: '研发修改'
            //     }
            // },
            {
                path: 'Science-addPersonnel',
                component: () => import('@/views/development-Administration/Science-projects/Science-addPersonnel'),
                meta: {
                    name: '项目详情'
                }
            },
            {
                path: 'industrial-design',
                component: () => import('@/views/development-Administration/industrial-design/industrial-design'),
                meta: {
                    name: '工业设计'
                }
            },
            // {
            //     path: 'industrial-modification',
            //     component: () => import('@/views/development-Administration/industrial-design/industrial-modification'),
            //     meta: {
            //         name: '项目修改'
            //     }
            // },
            // {
            //     path: 'industrial-addfication',
            //     component: () => import('@/views/development-Administration/industrial-design/industrial-addfication'),
            //     meta: {
            //         name: '作品新增'
            //     }
            // },
            // {
            //     path: 'industrial-detail',
            //     component: () => import('@/views/development-Administration/industrial-design/industrial-detail'),
            //     meta: {
            //         name: '作品详情'
            //     }
            // },
            {
                path: 'Patent-navigation',
                component: () => import('@/views/development-Administration/Patent-navigation/Patent-navigation'),
                meta: {
                    name: '专利导航'
                }
            },
            {
                path: 'navigation-report',
                component: () => import('@/views/development-Administration/Patent-navigation/navigation-report'),
                meta: {
                    name: '导航报告'
                }
            },
            {
                path: 'Technical-monitoring',
                component: () => import('@/views/development-Administration/Technical-monitoring/Technical-monitoring'),
                meta: {
                    name: '技术监控'
                }
            },
            {
                path: 'Monitoring-page',
                component: () => import('@/views/development-Administration/Technical-monitoring/Monitoring-page'),
                meta: {
                    name: '监控页面'
                }
            },
            {
                path: 'View-details',
                component: () => import('@/views/development-Administration/Technical-monitoring/View-details'),
                meta: {
                    name: '技术详情'
                }
            },
        ]
    },
    // 成果管理
    {
        path: '/Results-trading',
        component: () => import('@/views/Layout/Layout'),
        redirect: '/Results-trading/Results-management',
        meta: {
            name: '成果管理',
            haschild: false
        },
        children: [
            {
                path: 'Results-management',
                component: () => import('@/views/Results-trading/Results-management/Results-management'),
                meta: {
                    name: '成果管理'
                },
            },
            {
                path: 'Results-add',
                component: () => import('@/views/Results-trading/Results-management/Results-add'),
                meta: {
                    name: '成果新增'
                },
            },
            {
                path: 'Results-modify',
                component: () => import('@/views/Results-trading/Results-management/Results-modify'),
                meta: {
                    name: '成果修改'
                },
            },
            {
                path: 'Results-muchadd',
                component: () => import('@/views/Results-trading/Results-management/Results-muchadd'),
                meta: {
                    name: '成果附加'
                },
            },
            {
                path: 'value-assessment',
                component: () => import('@/views/Results-trading/value-assessment/value-assessment'),
                meta: {
                    name: '成果估值'
                },
            },
            // {
            //     path: 'assessment-report',
            //     component: () => import('@/views/Results-trading/assessment-report/assessment-report'),
            //     meta: {
            //         name: '评估报告'
            //     },
            // },
            {
                path: 'Achievement-entrustment',
                component: () => import('@/views/Results-trading/Achievement-entrustment/Achievement-entrustment'),
                meta: {
                    name: '成果出售'
                },
            },
            {
                path: 'Initiate-asale',
                component: () => import('@/views/Results-trading/Achievement-entrustment/Initiate-asale'),
                meta: {
                    name: '发起出售'
                },
            },
            {
                path: 'Initiate-edit',
                component: () => import('@/views/Results-trading/Achievement-entrustment/Initiate-edit'),
                meta: {
                    name: '出售编辑'
                },
            },
            {
                path: 'initiate-detail',
                component: () => import('@/views/Results-trading/Achievement-entrustment/initiate-detail'),
                meta: {
                    name: '出售详情'
                },
            },
            {
                path: 'initiate-my',
                component: () => import('@/views/Results-trading/Achievement-entrustment/initiate-my'),
                meta: {
                    name: '我的出售'
                },
            },
            {
                path: 'Achievement-introduction',
                component: () => import('@/views/Results-trading/Achievement-introduction/Achievement-introduction'),
                meta: {
                    name: '成果采购'
                },
            },
            {
                path: 'Sell-asale',
                component: () => import('@/views/Results-trading/Achievement-introduction/Sell-asale'),
                meta: {
                    name: '发起采购'
                },
            },
            {
                path: 'Sell-edit',
                component: () => import('@/views/Results-trading/Achievement-introduction/Sell-edit'),
                meta: {
                    name: '采购编辑'
                },
            },
            {
                path: 'Sell-detail',
                component: () => import('@/views/Results-trading/Achievement-introduction/Sell-detail'),
                meta: {
                    name: '采购详情'
                },
            },
            {
                path: 'Sell-my',
                component: () => import('@/views/Results-trading/Achievement-introduction/Sell-my'),
                meta: {
                    name: '我的采购'
                },
            },
            {
                path: 'Project-financing',
                component: () => import('@/views/Results-trading/Project-financing/Project-financing'),
                meta: {
                    name: '项目融资'
                },
            }
        ]
    },

    // 企业·网盘
    {
        path: '/Enterprise-networkdisk',
        component: () => import('@/views/Layout/Layout'),
        redirect: '/Enterprise-networkdisk/file-management',
        meta: {
            name: '档案云盘',
            haschild: true
        },
        children: [
            {
                path: 'file-management',
                component: () => import('@/views/Enterprise-networkdisk/file-management/file-management'),
                meta: {
                    name: '文件管理'
                }
            },
            {
                path: 'Permission-Settings',
                component: () => import('@/views/Enterprise-networkdisk/Permission-Settings/Permission-Settings'),
                meta: {
                    name: '分享管理'
                }
            },

        ]
    },
    // 研发费用
    {
        path: '/expenses-money',
        component: () => import('@/views/Layout/Layout'),
        redirect: '/expenses-money/Cost-collection',
        meta: {
            name: '研发费用',
            haschild: true
        },
        children: [
            {
                path: 'Cost-collection',
                component: () => import('@/views/expenses-money/Cost-collection/Cost-collection'),
                meta: {
                    name: '费用管理'
                }
            },
            {
                path: 'Financial-collection',
                component: () => import('@/views/expenses-money/Financial-collection/Financial-collection'),
                meta: {
                    name: '财务管理'
                }
            },
            {
                path: 'Payroll-statement',
                component: () => import('@/views/expenses-money/Payroll-statement/Payroll-statement'),
                meta: {
                    name: '工资报表'
                }
            },
            // {
            //     path: 'collection-add',
            //     component: () => import('@/views/expenses-money/Cost-collection/collection-add'),
            //     meta: {
            //         name: '费用归集新增'
            //     }
            // },
            // {
            //     path: 'collection-modify',
            //     component: () => import('@/views/expenses-money/Cost-collection/collection-modify'),
            //     meta: {
            //         name: '费用归集修改'
            //     }
            // },
            // {
            //     path: 'collection-detail',
            //     component: () => import('@/views/expenses-money/Cost-collection/collection-detail'),
            //     meta: {
            //         name: '费用归集详情'
            //     }
            // },
            {
                path: 'auxiliary-account',
                component: () => import('@/views/expenses-money/auxiliary-account/auxiliary-account'),
                meta: {
                    name: '研发辅助账'
                }
            },

        ]
    },

    // 行业瞭望
    {
        path: '/Industry-Outlook',
        component: () => import('@/views/Layout/Layout'),
        redirect: '/Industry-Outlook/Industry-report',
        meta: {
            name: '行业瞭望',
            haschild: true
        },
        children: [
            {
                path: 'Industry-report',
                component: () => import('@/views/Industry-Outlook/Industry-report/Industry-report'),
                meta: {
                    name: '产业报告'
                }
            },
            {
                path: 'Peer-attention',
                component: () => import('@/views/Industry-Outlook/Peer-attention/Peer-attention'),
                meta: {
                    name: '同行关注'
                }
            },
            {
                path: 'technology-information',
                component: () => import('@/views/Industry-Outlook/technology-information/technology-information'),
                meta: {
                    name: '科技资讯'
                }
            },
            {
                path: 'technology-detail',
                component: () => import('@/views/Industry-Outlook/technology-information/technology-detail'),
                meta: {
                    name: '资讯详情'
                }
            },

        ]
    },

    // 政策管家
    {
        path: '/Science-technology',
        component: () => import('@/views/Layout/Layout'),
        redirect: '/Science-technology/Policy-items',
        meta: {
            name: '政策管家',
            haschild: true
        },
        children: [
            {
                path: 'Policy-items',
                component: () => import('@/views/Science-technology/Policy-items/Policy-items'),
                meta: {
                    name: '政策列表'
                },
            },
            {
                path: 'Policyitems-details',
                component: () => import('@/views/Science-technology/Policy-items/Policyitems-details'),
                meta: {
                    name: '政策详情'
                },
            },
            {
                path: 'Policy-subscription',
                component: () => import('@/views/Science-technology/Policy-subscription/Policy-subscription'),
                meta: {
                    name: '我的订阅'
                },
            },
            {
                path: 'Intelligent-matching',
                component: () => import('@/views/Science-technology/Intelligent-matching/Intelligent-matching'),
                meta: {
                    name: '智能匹配'
                },
            },
            {
                path: 'Intelligent-declaration',
                component: () => import('@/views/Science-technology/Intelligent-declaration/Intelligent-declaration'),
                meta: {
                    name: '智能申报'
                },
            },
            {
                path: 'Policy-Template',
                component: () => import('@/views/Science-technology/Policy-Template/Policy-Template'),
                meta: {
                    name: '政策模板'
                },
            },
            {
                path: 'Policy-lookout',
                component: () => import('@/views/Science-technology/Policy-lookout/Policy-lookout'),
                meta: {
                    name: '政策瞭望台'
                },
            },
        ]
    },
    // 企业管理
    {
        path: '/business-management',
        component: () => import('@/views/Layout/Layout'),
        redirect: '/business-management/Member-Management',
        meta: {
            name: '企业管理',
            haschild: true
        },
        children: [
            {
                path: 'My-business',
                component: () => import('@/views/business-management/My-business/My-business'),
                meta: {
                    name: '我的企业'
                },
            },
            // {
            //     path: 'Collaborative-personnel',
            //     component: () => import('@/views/business-management/My-business/Collaborative-personnel'),
            //     meta: {
            //         name: '协同人员管理'
            //     },
            // },
            {
                path: 'Add-people',
                component: () => import('@/views/business-management/My-business/Add-people'),
                meta: {
                    name: '添加协同人员'
                },
            },
            // {
            //     path: 'Network-permission',
            //     component: () => import('@/views/business-management/My-business/Network-permission'),
            //     meta: {
            //         name: '网盘权限'
            //     },
            // },
            {
                path: 'Organizational',
                component: () => import('@/views/business-management/Organizational/Organizational'),
                meta: {
                    name: '组织架构管理'
                },
            },
            {
                path: 'Member-Management',
                component: () => import('@/views/business-management/Member-Management/Member-Management'),
                meta: {
                    name: '成员管理'
                },
            },
            // {
            //     path: 'Company-Profile',
            //     component: () => import('@/views/business-management/Company-Profile/Company-Profile'),
            //     meta: {
            //         name: '企业简介'
            //     },
            // },
            {
                path: 'Digital-assets',
                component: () => import('@/views/business-management/Digital-assets/Digital-assets'),
                meta: {
                    name: '数字资产'
                },
            },
            // {
            //     path: 'enterprise-data',
            //     component: () => import('@/views/business-management/enterprise-data/enterprise-data'),
            //     meta: {
            //         name: '企业数据'
            //     },
            // },
        ]
    },
    // 知识产权
    {
        path: '/intellectual-property',
        component: () => import('@/views/Layout/Layout'),
        redirect: '/intellectual-property/Management-patents',
        meta: {
            name: '知识产权',
            haschild: true
        },
        children: [
            {
                path: 'Management-patents',
                component: () => import('@/views/intellectual-property/Management-patents/Management-patents'),
                meta: {
                    name: '专利管理'
                },
            },
            {
                path: 'manage-details',
                component: () => import('@/views/intellectual-property/Management-patents/manage-details'),
                meta: {
                    name: '专利管理详情'
                },
            },
            {
                path: 'Manage-trademarks',
                component: () => import('@/views/intellectual-property/Manage-trademarks/Manage-trademarks'),
                meta: {
                    name: '商标管理'
                },
            },
            {
                path: 'Tradmanage-details',
                component: () => import('@/views/intellectual-property/Manage-trademarks/Tradmanage-details'),
                meta: {
                    name: '商标管理详情'
                },
            },
            {
                path: 'Soft-copyright',
                component: () => import('@/views/intellectual-property/Soft-copyright/Soft-copyright'),
                meta: {
                    name: '软著版权'
                },
            },
            {
                path: 'trandmark-application',
                component: () => import('@/views/intellectual-property/Online-application/trandmark-application'),
                meta: {
                    name: '商标在线申请'
                },
            },
            {
                path: 'Patent-application',
                component: () => import('@/views/intellectual-property/Online-application/Patent-application'),
                meta: {
                    name: '专利在线申请'
                },
            },
            {
                path: 'soft-application',
                component: () => import('@/views/intellectual-property/Online-application/soft-application'),
                meta: {
                    name: '软著在线申请'
                },
            },
            {
                path: 'Online-application',
                component: () => import('@/views/intellectual-property/Online-application/Online-application'),
                meta: {
                    name: '在线申请'
                },
            },
            {
                path: 'patent-lookout',
                component: () => import('@/views/intellectual-property/patent-lookout/patent-lookout'),
                meta: {
                    name: '专利瞭望台'
                },
            },
            {
                path: 'patentlookout-details',
                component: () => import('@/views/intellectual-property/patent-lookout/patentlookout-details'),
                meta: {
                    name: '专利详情'
                },
            },

            {
                path: 'trademark-lookout',
                component: () => import('@/views/intellectual-property/trademark-lookout/trademark-lookout'),
                meta: {
                    name: '商标瞭望台'
                },
            },
            {
                path: 'trademarklookout-details',
                component: () => import('@/views/intellectual-property/trademark-lookout/trademarklookout-details'),
                meta: {
                    name: '商标详情'
                },
            },
            {
                path: 'Through-rate',
                component: () => import('@/views/intellectual-property/Through-rate/Through-rate'),
                meta: {
                    name: '商标通过率检测'
                },
            },
            {
                path: 'Throughrate-details',
                component: () => import('@/views/intellectual-property/Through-rate/Throughrate-details'),
                meta: {
                    name: '商标通过率检测详情'
                },
            },
        ]
    },
    // 原创认证
    {
        path: '/Original-certification',
        component: () => import('@/views/Layout/Layout'),
        redirect: '/Original-certification/Certification-management',
        meta: {
            name: '原创认证',
            haschild: true
        },
        children: [
            {
                path: 'Certification-management',
                component: () => import('@/views/Original-certification/Certification-management/Certification-management'),
                meta: {
                    name: '认证管理'
                },
            },
            // {
            //     path: 'Application-certification',
            //     component: () => import('@/views/Original-certification/Certification-management/Application-certification'),
            //     meta: {
            //         name: '申请认证'
            //     },
            // },
        ]
    },
    // 科技金融
    {
        path: '/technology-finance',
        component: () => import('@/views/Layout/Layout'),
        redirect: '/technology-finance/Financing-management',
        meta: {
            name: '科技金融',
            haschild: true
        },
        children: [
            {
                path: 'Financing-management',
                component: () => import('@/views/technology-finance/Financing-management/Financing-management'),
                meta: {
                    name: '融资管理'
                }
            },
            // {
            //     path: 'Financing-add',
            //     component: () => import('@/views/technology-finance/Financing-management/Financing-add'),
            //     meta: {
            //         name: '新增融资'
            //     }
            // },
            // {
            //     path: 'Financing-modify',
            //     component: () => import('@/views/technology-finance/Financing-management/Financing-modify'),
            //     meta: {
            //         name: '融资修改'
            //     }
            // },
            // {
            //     path: 'Financing-detail',
            //     component: () => import('@/views/technology-finance/Financing-management/Financing-detail'),
            //     meta: {
            //         name: '融资详情'
            //     }
            // },
            {
                path: 'product-matching',
                component: () => import('@/views/technology-finance/product-matching/product-matching'),
                meta: {
                    name: '融资产品匹配'
                }
            },
        ]
    },
    // 科创保镖
    {
        path: '/Kechuang-Bodyguard',
        component: () => import('@/views/Layout/Layout'),
        redirect: '/Kechuang-Bodyguard/Online-warning',
        meta: {
            name: '科创保镖',
            haschild: true
        },
        children: [
            // {
            //     path: 'Online-warning',
            //     component: () => import('@/views/Kechuang-Bodyguard/Online-warning/Online-warning'),
            //     meta: {
            //         name: '在线预警'
            //     }
            // },
            // {
            //     path: 'Deposit-evidence',
            //     component: () => import('@/views/Kechuang-Bodyguard/Deposit-evidence/Deposit-evidence'),
            //     meta: {
            //         name: '存证取证'
            //     }
            // },
        ]
    },
    // 合同管理
    {
        path: '/contract-management',
        component: () => import('@/views/Layout/Layout'),
        redirect: '/contract-management/Enterprise-contract',
        meta: {
            name: '合同管理',
            haschild: true
        },
        children: [
            {
                path: 'Enterprise-contract',
                component: () => import('@/views/contract-management/Enterprise-contract/Enterprise-contract'),
                meta: {
                    name: '企业合同'
                }
            },
            {
                path: 'Enterprise-addfication',
                component: () => import('@/views/contract-management/Enterprise-contract/Enterprise-addfication'),
                meta: {
                    name: '合同增加'
                }
            },
            {
                path: 'Enterprise-modification',
                component: () => import('@/views/contract-management/Enterprise-contract/Enterprise-modification'),
                meta: {
                    name: '合同修改'
                }
            },
            {
                path: 'Enterprise-detail',
                component: () => import('@/views/contract-management/Enterprise-contract/Enterprise-detail'),
                meta: {
                    name: '合同详情'
                }
            },
            {
                path: 'Housekeeper-contract',
                component: () => import('@/views/contract-management/Housekeeper-contract/Housekeeper-contract'),
                meta: {
                    name: '管家合同'
                }
            },
        ]
    },
    // 消息中心
    {
        path: '/Message-Center',
        component: () => import('@/views/Layout/Layout'),
        redirect: '/Message-Center/Messages',
        meta: {
            name: '消息中心',
            haschild: true
        },
        children: [
            {
                path: 'Messages',
                component: () => import('@/views/Message-Center/Messages/Messages'),
                meta: {
                    name: '消息中心'
                }
            },
        ]
    },
    // 个人中心
    {
        path: '/Personal-Center',
        component: () => import('@/views/Layout/Layout'),
        redirect: '/Personal-Center/personal-homepage',
        meta: {
            name: '个人中心',
            haschild: true
        },
        children: [
            {
                path: 'personal-homepage',
                component: () => import('@/views/Personal-Center/personal-homepage/personal-homepage'),
                meta: {
                    name: '个人中心首页'
                },
            },
            {
                path: 'Trademarks-Concern',
                component: () => import('@/views/Personal-Center/Trademarks-Concern/Trademarks-Concern'),
                meta: {
                    name: '我关注的商标'
                },
            },
            {
                path: 'Trademark-Sharing',
                component: () => import('@/views/Personal-Center/Trademark-Sharing/Trademark-Sharing'),
                meta: {
                    name: '我分享的商标'
                },
            },
            {
                path: 'Enterprises-Interest',
                component: () => import('@/views/Personal-Center/Enterprises-Interest/Enterprises-Interest'),
                meta: {
                    name: '我关注的企业'
                },
            },
            {
                path: 'Enterprises-Sharing',
                component: () => import('@/views/Personal-Center/Enterprises-Sharing/Enterprises-Sharing'),
                meta: {
                    name: '我分享的企业'
                },
            },
            {
                path: 'patent-Interest',
                component: () => import('@/views/Personal-Center/patent-Interest/patent-Interest'),
                meta: {
                    name: '我关注的专利'
                },
            },
            {
                path: 'patent-Sharing',
                component: () => import('@/views/Personal-Center/patent-Sharing/patent-Sharing'),
                meta: {
                    name: '我分享的专利'
                },
            },
            {
                path: 'Enterprise-Certification',
                component: () => import('@/views/Personal-Center/Enterprise-Certification/Enterprise-Certification'),
                meta: {
                    name: '企业认证申请'
                },
            },
            {
                path: 'joined-enterprise',
                component: () => import('@/views/Personal-Center/joined-enterprise/joined-enterprise'),
                meta: {
                    name: '我加入的企业'
                },
            },
            {
                path: 'message-reminds',
                component: () => import('@/views/Personal-Center/message-reminds/message-reminds'),
                meta: {
                    name: '我的消息提醒'
                },
            },
            {
                path: 'reminder-schedule',
                component: () => import('@/views/Personal-Center/reminder-schedule/reminder-schedule'),
                meta: {
                    name: '我的日程提醒'
                },
            },
            {
                path: 'Sharing-Management',
                component: () => import('@/views/Personal-Center/Sharing-Management/Sharing-Management'),
                meta: {
                    name: '文件分享管理'
                },
            },

        ]
    },
]

// 解决重复点击路由重复问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
// 实例
const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

// 设置全局前置守卫
/* 
    to:Object
        - 要去到的路由
    from:Object
        - 从哪儿出发的路由
    next:function
        - 放行
        - 强制重定向
*/
router.beforeEach((to, from, next) => {
    if (to.matched.length === 0) {  //如果未匹配到路由
        from.name ? next({ name: from.name }) : next('/home');   //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
    } else {
        next();    //如果匹配到正确跳转
    }
    let token = VueCookie.get("token")

    // if (token) {
    //     next()
    // } else {
    //     if (to.path === '/login') {
    //         next()
    //     }
    //     else {
    //         // 使用replace重定向
    //         // replace的作用：覆盖当前路由的history记录
    //         router.replace('/login')
    //         // next('/login')
    //     }
    // }

    if (token) {
        to.path === '/home'
        window.sessionStorage.setItem("token", token);
        window.localStorage.setItem("token", token)
        VueCookie.set("token", token, 14 * 24 * 60 * 60);
    } else {
        localStorage.clear();
        let token = VueCookie.get("token");
        VueCookie.set("token", token, -2); //删除
        to.path === '/login'
        if (to.path === '/login') {
            next()
        }
        else {
            // 使用replace重定向
            // replace的作用：覆盖当前路由的history记录
            router.replace('/login')
            // next('/login')
        }
    }
})

export default router